const SAITAMA_CITY_ACCESS_KEY = "k8m2v7q4x9n1c6p3w5r0d2fz";
const NTT_FT_ACCESS_KEY = "z7n3q9m1x4p2v0ydk8twr5fb";
const SAITAMA_CITY_SEASON_ID = "cmuj8rted00010lnwciotguzf";

const SAITAMA_SEASON_ACCESS_KEYS = Object.freeze([
  SAITAMA_CITY_ACCESS_KEY,
  NTT_FT_ACCESS_KEY,
]);

const SAITAMA_CITY_PROVIDER = {
  label: "さいたま市",
  company: "saitama-city",
  accessKey: SAITAMA_CITY_ACCESS_KEY,
};

const isSaitamaSeasonAccessKey = (accessKey) =>
  SAITAMA_SEASON_ACCESS_KEYS.includes(accessKey);

const isSaitamaSeasonSelected = (accessKey, seasonId) =>
  isSaitamaSeasonAccessKey(accessKey) && seasonId === SAITAMA_CITY_SEASON_ID;

const filterSaitamaSeasonVisibility = (seasons, accessKey) => {
  if (accessKey === SAITAMA_CITY_ACCESS_KEY) {
    return seasons.filter((season) => season.seasonId === SAITAMA_CITY_SEASON_ID);
  }

  if (isSaitamaSeasonAccessKey(accessKey)) {
    return seasons;
  }

  return seasons.filter((season) => season.seasonId !== SAITAMA_CITY_SEASON_ID);
};

const shouldAutoSelectSaitamaSeason = (accessKey) =>
  accessKey === SAITAMA_CITY_ACCESS_KEY;

export {
  SAITAMA_CITY_ACCESS_KEY,
  NTT_FT_ACCESS_KEY,
  SAITAMA_CITY_PROVIDER,
  SAITAMA_CITY_SEASON_ID,
  SAITAMA_SEASON_ACCESS_KEYS,
  isSaitamaSeasonAccessKey,
  isSaitamaSeasonSelected,
  filterSaitamaSeasonVisibility,
  shouldAutoSelectSaitamaSeason,
};
